/**
 * Public entry point for the `dm-monitor-and-protect` zone.
 *
 * Cross-zone consumers (e.g. `sales`) must import symbols from this barrel only,
 * never from deep paths inside the zone. Curated by the M&P owners.
 */
import { lazyWithSuspense } from "./app/loading";

export { ROUTES as MONITOR_AND_PROTECT_ROUTES } from "./app/keywords/constants";
export { MonitorAndProtectRoot } from "./app/keywords/monitor-and-protect-root";
export type {
    MonitorAndProtectParamKeys,
    MonitorAndProtectParamsDefinition,
    MonitorAndProtectStateDeclaration,
} from "./app/keywords/routes.types";
export { TRADEMARK_ROUTES } from "./app/trademark/constants";
export { monitorAndProtectNavigation } from "./app/monitor-and-protect-navigation";
export { MonitorAndProtectTrademarkRoot } from "./app/trademark/root";
export type {
    MonitorAndProtectTrademarkParamKeys,
    MonitorAndProtectTrademarkParamsDefinition,
} from "./app/trademark/routes.types";
export { AdsPage } from "./features/ads-report";
export { CompetitorsReport } from "./features/competitors-report";
export { Homepage } from "./features/homepage";
export const OverviewPageLazy = lazyWithSuspense(() => import("./features/overview/overview.page"));
export const KeywordsPageLazy = lazyWithSuspense(() => import("./features/keywords/keywords.page"));
export const CampaignSettingsPageLazy = lazyWithSuspense(
    () => import("./features/campaign-settings/campaign-settings.page"),
);
export { TrademarkConfigsCreatePage } from "./features/trademark-config-create/trademark-config-create.page";
export { TrademarkConfigsEditPage } from "./features/trademark-config-edit/trademark-config-edit.page";
export { TrademarkConfigsPage } from "./features/trademark-config-list/trademark-configs.page";
export { TrademarkDashboardRoot } from "./features/trademark-violations/trademark-violations-root";
export { onRedirectHandler, onRedirectToMonitorAndProtectReport } from "./shared/on-redirect-handler";
export { durationResetHandler } from "./shared/redirect-handlers/trademarks/duration-reset";
export { createParamsResetHandler } from "./shared/redirect-handlers/trademarks/params-reset-factory";
export type { IRedirectCase } from "./shared/redirect-handlers/types";
